var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client-only',[_c('div',{staticClass:"scroller"},[_c('div',{class:['scroller__wrapper', { 'scroller__wrapper--freeze': _vm.freeze }]},[_c('div',{staticClass:"scroller__content"},[_vm._t("default")],2)])])])}
var staticRenderFns = []

export { render, staticRenderFns }